export const ContactContainer = {
  width: "100%",
  maxWidth: 1500,
  display: "flex",
  gap: "8px",
  alignSelf: "center",
  marginTop: "16px",
  border: "1px solid #ccc",
  WebkitBoxShadow: "1px 1px 8px -5px #000000",
  boxShadow: "1px 1px 8px -5px #000000",
};

export const ContentRowHeader = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  justifyContent: "space-between",
  alignItems: { xs: "flex-start", sm: "center" },
  gap: 1,
  width: "100%",
};
